/**
 * file : RealRanking/Tournament.jsx
 * 설명 : 토너먼트별 랭킹
 */

import { Fnc } from "common/globals";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SSE } from 'components/Common/ApiCall';
import { useEffect, useState, useRef } from "react";
import { Select } from "components/Common/Componentization";

export default function Tournament( props ) {
  // 공통 값
  const common = useSelector(state => state.Common);
  // 접속자 토큰 정보
  const { token } = useSelector(state => state.Client);
  // 토큰 정보 추출
  const info = Fnc.TokenSubstitution(token.access_token);
  // 데이터
  const [datas, setDatas] = useState();
  // 조회 조건
  const searchWhereRef = useRef({});
  // 조회 조건 할당
  const searchWherePut = (key, val) => {
    props.setDataLoading(true)
    searchWhereRef.current = { ...searchWhereRef.current, [key]: val }
  };
  // 리스트 갯수
  const [listCount, setListCount] = useState(5)
  const showMore = () => {
    let count = listCount > datas.length ? datas.length : listCount + 5
    setListCount(count);
  }
  // SSE 통신
  useEffect(() => {
    props.setDataLoading(true);
    const { start, stop } = SSE();

    start('/ranking',
      (result) => {
        const { tournament_idx, user_idx } = searchWhereRef.current;
        if (!Fnc.Empty(tournament_idx)) result = result.filter((item) => item.tournament_idx === Number(tournament_idx));
        if (!Fnc.Empty(user_idx)) result = result.filter((item) => item.user_idx === user_idx);

        setDatas(result);
        props.setDataLoading(false);
      }, (err) => {
        console.error('SSE Ranking 통신 중 오류:', err);
        props.setDataLoading(false);
      }
    );

    return () => {
      stop();
    };
  }, []);


  return (
    <div className="zeus-tab-item tab-show">
      <div className="search_box margin-bottom-10">
        <Select elementKey="tournament_idx" placeholder="진행 중인 토너먼트 선택" options={common.tournaments.s} insert={searchWherePut} />
        <div className="check__ text-end" >
          <input id="tournament" type="checkbox" onChange={(e) => searchWherePut('user_idx', e.target.checked ? info.idx : '')}/>
          <label htmlFor="tournament"><span className="color-white">나의 순위 보기</span></label>
        </div>
      </div>
      <div className="table-container">
        <table className="table_style1">
          <thead>
            <tr>
              <th>토너먼트</th>
              <th>랭킹</th>
              <th>회원 ID</th>
              <th>베팅 금액</th>
              <th>당첨 금액</th>
              <th>예상 상금 금액</th>
            </tr>
          </thead>
          <tbody>
            {
              !Fnc.Empty(datas) && datas.slice(0, listCount).map((data, index) => (
                <tr key={index}>
                  <td>{data.tournament_name}</td>
                  <td>{data.rank}위</td>
                  <td>
                    {data.user_id}
                    {data.user_idx === info.idx && <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -910 960 960" width="25px" fill="#0D7EE7"><path d="m344-60-76-128-144-32 14-148-98-112 98-112-14-148 144-32 76-128 136 58 136-58 76 128 144 32-14 148 98 112-98 112 14 148-144 32-76 128-136-58-136 58Zm34-102 102-44 104 44 56-96 110-26-10-112 74-84-74-86 10-112-110-24-58-96-102 44-104-44-56 96-110 24 10 112-74 86 74 84-10 114 110 24 58 96Zm102-318Zm-42 142 226-226-56-58-170 170-86-84-56 56 142 142Z" /></svg>}
                  </td>
                  <td className="align_r font_style1"><span className="won"></span>{data.bet_money.toLocaleString()}</td>
                  <td className="align_r font_style1"><span className="won"></span>{data.win_money.toLocaleString()}</td>
                  <td className="align_r txt_org font_style1"><span className="won txt_org"></span>{Number(data.prize_money).toLocaleString()}</td>
                </tr>
              ))
            }
          </tbody>
        </table>
        { Fnc.Empty(datas) && <div className='table-no-data'>내역이 존재하지 않아요</div> }
        {
          !Fnc.Empty(datas) &&
          listCount < datas.length && (
            <div className="btns_wrap mt_30 mb_30">
              <Link className="btn_more" onClick={showMore}>더불러오기</Link>
            </div>
          )
        }
      </div>
    </div>
  )
}